export function waitTimeout(ms, setTimerFunc) {
  return new Promise(resolve => {
    const timer = setTimeout(resolve, ms);
    if (setTimerFunc !== undefined) {
      setTimerFunc(timer);
    }
  });
}
